import React, { useState } from 'react';
import { ZoomIn, X } from 'lucide-react';
const images = [{
  url: 'https://www.6gtools.com/uploaded/images/products/MAF177CR-S.webp',
  alt: 'High Performance End Mill M A Ford Series 177',
  title: 'Corner Radius End Mill TuffCutt®XR 4 Flute M A Ford'
}, {
  url: 'https://www.6gtools.com/uploaded/images/Dimensions/Corner-Radius-End-Mill-Dimensions.webp',
  alt: 'Corner Radius End Mill Dimensions',
  title: 'Corner Radius End Mill Dimensions'
}];
const SUMMARY_SPECS = ['DIA=20mm', 'LOC=38mm', 'OAL=104mm', 'SHK=20.0mm', 'CR=3.0mm'];
export function ProductGallery() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const active = images[activeIndex];
  return <div className="flex flex-col gap-4 max-w-md" data-id="element-458" data-mp="3pu18mpp6l19k">
      {/* Main Image (square, gold action frame) */}
      <div className="relative aspect-square bg-white border-2 border-brand-darkGold rounded-lg overflow-hidden" data-id="element-459" data-mp="3uskw4ujfal41">
        <div className="absolute inset-0 flex items-center justify-center p-4" data-id="element-460" data-mp="34ozlu4v2xdy5">
          <img src={active.url} alt={active.alt} title={active.title} className="max-w-full max-h-full object-contain" data-id="element-461" data-mp="2zqy0fda6l2ji" />
        </div>

        {/* Enlarge / zoom button */}
        <button type="button" onClick={() => setLightboxOpen(true)} aria-label="Enlarge image" className="absolute top-3 right-3 bg-white/95 hover:bg-white border border-brand-darkGold rounded-md p-2 shadow-sm text-brand-charcoal transition-colors" data-id="element-462" data-mp="38sfgivnl9487">
          <ZoomIn className="w-5 h-5" data-id="element-463" data-mp="2usmpez85glzp" />
        </button>

        {/* Summary spec overlay */}
        <div className="absolute bottom-0 inset-x-0 bg-brand-charcoal/90 text-white px-4 py-2.5 flex flex-wrap justify-center gap-x-5 gap-y-1 text-xs sm:text-sm font-mono" data-id="element-464" data-mp="2pztnej42frrb">
          {SUMMARY_SPECS.map(s => <span key={s} data-id="element-465" data-mp="1xbflhs9uwbah">{s}</span>)}
        </div>
      </div>

      {/* Thumbnails */}
      <div className="flex gap-4" data-id="element-466" data-mp="189kus0y3db8">
        {images.map((img, idx) => <button key={idx} onClick={() => setActiveIndex(idx)} className={`relative w-20 h-20 bg-white border-2 rounded-md overflow-hidden p-1 transition-colors ${activeIndex === idx ? 'border-brand-darkGold' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-467" data-mp="67dt9gg1p70i" data-mpi={idx}>
            <img src={img.url} alt={img.alt} title={img.title} className="w-full h-full object-contain" data-id="element-468" data-mp="3ege2ue5o0imy" />
          </button>)}
      </div>

      {/* Lightbox */}
      {lightboxOpen && <div className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label="Product image preview" onClick={() => setLightboxOpen(false)} data-id="element-469" data-mp="3sfdore1smjff">
          <div className="relative bg-white rounded-lg max-w-3xl w-full max-h-[90vh] flex items-center justify-center p-6" onClick={e => e.stopPropagation()} data-id="element-470" data-mp="17njyly0v2wcf">
            <button type="button" onClick={() => setLightboxOpen(false)} aria-label="Close image preview" className="absolute top-3 right-3 bg-white border border-gray-200 hover:border-brand-darkGold rounded-md p-2 shadow-sm text-brand-charcoal transition-colors" data-id="element-471" data-mp="2o63sxsge4gc8">
              <X className="w-5 h-5" data-id="element-472" data-mp="24hkzgyocqgrq" />
            </button>
            <img src={active.url} alt={active.alt} title={active.title} className="max-w-full max-h-[80vh] object-contain" data-id="element-473" data-mp="24g1if5uvg1ow" />
          </div>
        </div>}
    </div>;
}